import { isProd } from './config';

import { enableInProductionOrUseLocalOverride } from './util/enable-in-production-or-use-local-override';

const isFlagBooleanDefined = (property: string) =>
  process.env[property] !== undefined && process.env[property] !== '';

export const ENABLE_PRODUCT_TELEMETRY = enableInProductionOrUseLocalOverride(
  'REACT_APP_ENABLE_PRODUCT_TELEMETRY',
);

// For local development, we can use this variable to toggle all feature gates on / off
// without needing to hit the metrics service.
// If no default value is set, we will call the local metrics service endpoint.
export const DEV_DEFAULT_FEATURE_GATE_ENABLED =
  !isProd && isFlagBooleanDefined('REACT_APP_DEV_DEFAULT_FEATURE_GATE_ENABLED')
    ? process.env.REACT_APP_DEV_DEFAULT_FEATURE_GATE_ENABLED === 'true'
    : null;
